// extracted by mini-css-extract-plugin
export default {"root":"bg_root__fjJXn","imgBox":"bg_imgBox__rSw2c"};